<template>
  <div>
    <Title
      title="Enviar Visitas A Simpliroute Web"
      subtitle="Envia visitas y configura tus rutas en simpliroute web"/>
    <div v-if="planningTracker === null">
      <el-row :gutter="30">
        <el-col>

        </el-col>
        <el-col :md="10">
          <ExtraData v-model="extraData"
                     @errors="getExtraDataErrors"/>
        </el-col>

        <el-col>

        </el-col>
        <el-col>
          <PlanningCheck 
                         :suborders="suborderErrors"
                         :extraData="extraDataErrors"
                         @validPlanning="getValidation"/>
        </el-col>
        <el-col>
          <SuborderList ref="suborderList"
                        v-model="suborders"
                        :sectors="sectorsToSoc"
                        :dataToGetTO="dataToGetTO"
                        @updateCode="updateCode"
                        @errors="getSuborderErrors"
                        @countSocWithoutSector="getCountSocWithoutSector"/>
        </el-col>
        <el-col>
          <PlanningSend :sectors="sectorList"
                        :extraData="extraData"
                        :historyCode="historyCode"
                        :validPlanning="checkedPlanning"
                        :suborders="suborders"
                        :countSocWithoutSector="countSocWithoutSector"
                        @subordersFiltered="handleSubordersFiltered"
                        @batchCompleted="handleBatchCompleted"
                        @batchFailed="handleBatchFailed"
                        @batchCancelled="handleBatchCancelled"/>
        </el-col>
      </el-row>
    </div>
    <el-row v-else>
      <el-col>
        <PlanningSuccess :planningTracker="planningTracker"/>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Title from '../components/base/Title.vue';
import SectorMap from '../components/planningSimpliroute/sector/Map.vue';
import SectorList from '../components/planningSimpliroute/sector/List.vue';
import ConfigPanel from '../components/planningSimpliroute/config/Panel.vue';
import PlanningSend from '../components/planningSimpliroute/general/Send.vue';
import SuborderList from '../components/planningSimpliroute/suborder/List.vue';
import ExtraData from '../components/planningSimpliroute/general/ExtraData.vue';
import PlanningCheck from '../components/planningSimpliroute/general/Check.vue';
import PlanningSuccess from '../components/planningSimpliroute/general/Success.vue';
import { trackBusinessFlow } from '@/observability/datadogRum';

export default {
  name: 'PlanningSimpliroute',
  components: {
    Title,
    ExtraData,
    SectorMap,
    SectorList,
    ConfigPanel,
    SuborderList,
    PlanningSend,
    PlanningCheck,
    PlanningSuccess,
  },
  data() {
    return {
      sectors: [],
      extraData: {},
      suborders: [],
      countSector: 0,
      historyCode: '',
      sectorErrors: [],
      suborderErrors: [],
      extraDataErrors: [],
      planningTracker: null,
      checkedPlanning: false,
      countSocWithoutSector: 0,
    };
  },
  mounted() {
  },
  methods: {
    parseSimplirouteErrorDetail(detail) {
      if (!detail) {
        return null;
      }
      if (typeof detail === 'object') {
        return detail;
      }
      try {
        return JSON.parse(detail);
      } catch (e) {
        return null;
      }
    },
    classifySimplirouteError(error) {
      const parsedDetail = this.parseSimplirouteErrorDetail(error && error.detail);
      if (parsedDetail) {
        if (parsedDetail.contact_email || parsedDetail.reference || parsedDetail.address
          || parsedDetail.phone || parsedDetail.contact_name) {
          return 'functional';
        }
        return 'functional';
      }

      const detailText = String(error && error.detail ? error.detail : '').toLowerCase();
      if (detailText.includes('timeout') || detailText.includes('gateway')
        || detailText.includes('internal server error') || detailText.includes('network')
        || detailText.includes('temporar') || detailText.includes('unavailable')) {
        return 'technical';
      }

      return detailText ? 'functional' : 'technical';
    },
    getSimplirouteErrorSummary(errors) {
      return (errors || []).reduce((summary, error) => {
        const category = this.classifySimplirouteError(error);
        if (category === 'technical') {
          summary.technical += 1;
        } else {
          summary.functional += 1;
        }
        return summary;
      }, { functional: 0, technical: 0 });
    },
    updateCode(code) {
      this.historyCode = code;
    },
    successPlanning(id) {
      this.planningTracker = id;
    },
    // Método para manejar subórdenes filtradas por estado
    handleSubordersFiltered(filteredSuborders) {
      console.log('handleSubordersFiltered llamado con:', filteredSuborders);
      trackBusinessFlow({
        module: 'planning',
        flow: 'simpliroute_visits',
        action: 'filtered_suborders_processed',
        status: 'success',
        context: {
          history_code: this.historyCode,
          filtered_suborders: filteredSuborders.length,
        },
      });
      
      // Marcar subórdenes filtradas con observaciones
      filteredSuborders.forEach(suborder => {
        const index = this.suborders.findIndex(s => s.suborder === suborder.suborder);
        console.log(`Buscando subórden ${suborder.suborder}, índice encontrado: ${index}`);
        
        if (index !== -1) {
          // Agregar observación
          if (!this.suborders[index].observations) {
            this.suborders[index].observations = [];
          }
          
          // Determinar el mensaje según el estado
          let message = '';
          switch (suborder.last_state_name) {
            case 'Cancelado':
              message = 'No enviada - Estado: Cancelado';
              break;
            case 'Terminado':
              message = 'No enviada - Estado: Terminado';
              break;
            case 'En ruta':
              message = 'No enviada - Estado: En ruta';
              break;
            default:
              message = 'No enviada - Estado no válido para envío';
          }
          
          this.suborders[index].observations.push({
            message: message,
            timestamp: new Date().toISOString(),
            type: 'warning'
          });
          
          // Marcar como con error para estilos visuales
          this.suborders[index].hasError = true;
          this.suborders[index].errorType = 'filtered';
          
          console.log(`Subórden ${suborder.suborder} marcada con observación:`, this.suborders[index].observations);
        }
      });
      
      // Mostrar notificación informativa
      this.$notify({
        type: 'info',
        title: 'Subórdenes filtradas',
        message: `${filteredSuborders.length} subórdenes fueron filtradas por estado y no se enviarán.`,
      });
    },
    // Métodos para manejar el progreso del batch de Simpliroute
    handleBatchCompleted(data) {
      console.log('=== handleBatchCompleted INICIO ===');
      console.log('Data recibida:', data);
      console.log('Subórdenes actuales:', this.suborders.length);
      console.log('processedSuborders:', data.processedSuborders);
      console.log('filteredSuborders:', data.filteredSuborders);
      console.log('errors:', data.errors);
      
      // No asignar planningTracker para evitar redirección a vista de éxito
      // this.planningTracker = data.batchId; // Usar batchId como identificador
      
      // Actualizar el listado de subórdenes - remover las procesadas exitosamente PRIMERO
      if (data.processedSuborders && data.processedSuborders.length > 0) {
        console.log('Llamando removeProcessedSuborders con:', data.processedSuborders);
        this.removeProcessedSuborders(data.processedSuborders);
      } else {
        console.log('No hay processedSuborders en la respuesta - usando totalCreated');
        // Si no hay processedSuborders, usar totalCreated para crear una lista
        if (data.totalCreated && data.totalCreated > 0) {
          console.log('Creando lista de procesadas basada en totalCreated:', data.totalCreated);
          // Crear una lista de subórdenes procesadas basada en totalCreated
          const processedSuborders = this.suborders
            .filter(s => !s.hasError) // Solo las que no tienen errores
            .slice(0, data.totalCreated); // Tomar las primeras N
          console.log('Subórdenes a remover:', processedSuborders);
          this.removeProcessedSuborders(processedSuborders);
        }
      }
      
      // Procesar errores DESPUÉS de remover las procesadas exitosamente
      // Esto asegura que las observaciones se agreguen a las subórdenes que quedan
      if (data.errors && data.errors.length > 0) {
        console.log('=== PROCESANDO ERRORES DESPUÉS DE FILTRAR ===');
        console.log('Errores a procesar:', data.errors);
        console.log('Subórdenes disponibles después de filtrar:', this.suborders.length);
        console.log('Subórdenes detalladas:', this.suborders.map(s => ({ 
          suborder: s.suborder, 
          lpn: s.lpn,
          last_state_name: s.last_state_name,
          hasError: s.hasError,
          observations: s.observations
        })));
        this.processSimplirouteErrors(data.errors);
      }
      
      // Las observaciones ya se agregaron en handleSubordersFiltered
      // No es necesario agregarlas nuevamente aquí
      console.log('=== handleBatchCompleted FIN ===');
      
      // Mostrar notificación con el resultado
      const totalProcessed = data.totalCreated || 0;
      const totalErrors = data.errors ? data.errors.length : 0;
      const totalFiltered = data.filteredSuborders ? data.filteredSuborders.length : 0;
      const errorSummary = this.getSimplirouteErrorSummary(data.errors);
      trackBusinessFlow({
        module: 'planning',
        flow: 'simpliroute_visits',
        action: 'batch_completed',
        status: totalErrors > 0 || totalFiltered > 0 ? 'partial_success' : 'success',
        context: {
          history_code: this.historyCode,
          batch_id: data.batchId,
          total_processed: totalProcessed,
          total_errors: totalErrors,
          total_filtered: totalFiltered,
          functional_errors: errorSummary.functional,
          technical_errors: errorSummary.technical,
        },
      });
      
      // Crear mensaje más detallado
      let title = '¡Proceso completado!';
      let message = `📊 RESUMEN DEL ENVÍO:\n\n`;
      message += `✅ ${totalProcessed} órdenes enviadas exitosamente (removidas del listado)\n`;
      
      if (totalFiltered > 0) {
        message += `⚠️ ${totalFiltered} órdenes filtradas por estado (mantenidas en el listado)\n`;
      }
      if (totalErrors > 0) {
        message += `❌ ${totalErrors} órdenes con errores (mantenidas en el listado)\n`;
      }
      
      message += `\n📋 Total procesado: ${totalProcessed + totalFiltered + totalErrors} órdenes`;
      
      if (totalErrors > 0 || totalFiltered > 0) {
        title = 'Proceso completado con observaciones';
      }
      
      this.$notify({
        type: totalErrors > 0 || totalFiltered > 0 ? 'warning' : 'success',
        title: title,
        message: message,
        duration: 8000, // Mostrar por más tiempo para que el usuario lea el resumen
        dangerouslyUseHTMLString: true, // Permitir saltos de línea
      });
      
      // El modal se cierra automáticamente desde Summary.vue
    },
    handleBatchFailed(data) {
      console.error('Error en el procesamiento del batch:', data);
      const errorSummary = this.getSimplirouteErrorSummary(data && data.errors);
      trackBusinessFlow({
        module: 'planning',
        flow: 'simpliroute_visits',
        action: 'batch_failed',
        status: 'error',
        context: {
          history_code: this.historyCode,
          batch_id: data && data.batchId,
          errors_count: data && data.errors ? data.errors.length : 0,
          functional_errors: errorSummary.functional,
          technical_errors: errorSummary.technical,
        },
      });
      
      // Procesar errores específicos de Simpliroute
      if (data.errors && data.errors.length > 0) {
        console.log('Procesando errores de Simpliroute:', data.errors);
        this.processSimplirouteErrors(data.errors);
        
        // Mostrar notificación con resumen de errores
        this.$notify({
          type: 'warning',
          title: 'Proceso completado con errores',
          message: `Se encontraron ${data.errors.length} errores en el procesamiento. Revisa las observaciones en el listado.`,
        });
      }
    },
    
    // Método reutilizable para procesar errores de Simpliroute
    processSimplirouteErrors(errors) {
      console.log('=== processSimplirouteErrors INICIO ===');
      console.log('Errores a procesar:', errors);
      console.log('Subórdenes disponibles:', this.suborders.map(s => ({ 
        suborder: s.suborder, 
        lpn: s.lpn,
        suborderType: typeof s.suborder,
        lpnType: typeof s.lpn
      })));
      
      errors.forEach(error => {
        console.log('Procesando error individual:', error);
        const errorCategory = this.classifySimplirouteError(error);
        
        // Buscar la subórden correspondiente por SOC o LPN
        // Convertir a string para comparación más robusta
        const errorSoc = String(error.soc);
        const errorLpn = String(error.lpn);
        
        const suborderIndex = this.suborders.findIndex(s => 
          String(s.suborder) === errorSoc || String(s.lpn) === errorLpn
        );
        
        console.log(`Búsqueda de subórden - SOC: ${error.soc} (${typeof error.soc}), LPN: ${error.lpn} (${typeof error.lpn}), Índice encontrado: ${suborderIndex}`);
        console.log(`Valores convertidos - errorSoc: ${errorSoc}, errorLpn: ${errorLpn}`);
        
        if (suborderIndex !== -1) {
          console.log(`Procesando error para subórden ${this.suborders[suborderIndex].suborder}:`, error);
          console.log(`Observaciones existentes:`, this.suborders[suborderIndex].observations);
          
          // Inicializar observaciones si no existen
          if (!this.suborders[suborderIndex].observations) {
            this.suborders[suborderIndex].observations = [];
          }
          
          // Parsear el detalle del error si viene como JSON string
          let errorMessage = '';
          const errorDetail = this.parseSimplirouteErrorDetail(error.detail);
          try {
            console.log('Error detail parseado:', errorDetail);
            if (errorDetail && errorDetail.contact_email) {
              errorMessage = `Error de validación: ${errorDetail.contact_email.join(', ')}`;
            } else if (errorDetail && errorDetail.reference) {
              errorMessage = `Error en referencia: ${errorDetail.reference}`;
            } else {
              errorMessage = `Error de procesamiento: ${error.detail}`;
            }
          } catch (e) {
            console.log('Error parseando JSON, usando detalle tal como viene:', error.detail);
            // Si no es JSON válido, usar el detalle tal como viene
            errorMessage = `Error de procesamiento: ${error.detail}`;
          }
          
          console.log('Mensaje de error generado:', errorMessage);
          
          // Verificar si ya existe esta observación de error para evitar duplicados
          const existingErrorObservation = this.suborders[suborderIndex].observations.find(obs => 
            obs.message === errorMessage && obs.type === 'error'
          );
          
          if (!existingErrorObservation) {
            // Agregar observación de error
            this.suborders[suborderIndex].observations.push({
              message: errorMessage,
              timestamp: new Date().toISOString(),
              type: 'error',
              category: errorCategory,
            });
            console.log('Observación agregada exitosamente');
          } else {
            console.log('Observación ya existe, no se agrega duplicado');
          }
          
          // Marcar como con error para estilos visuales (preservar errorType existente si es 'filtered')
          this.suborders[suborderIndex].hasError = true;
          if (this.suborders[suborderIndex].errorType !== 'filtered') {
            this.suborders[suborderIndex].errorType = errorCategory;
          }
          
          console.log(`Subórden ${this.suborders[suborderIndex].suborder} marcada con error:`, errorMessage);
          console.log(`Observaciones finales:`, this.suborders[suborderIndex].observations);
          
          // Forzar reactividad de Vue
          this.$set(this.suborders, suborderIndex, {
            ...this.suborders[suborderIndex],
            observations: [...this.suborders[suborderIndex].observations]
          });
          
          console.log(`Subórden después de $set:`, this.suborders[suborderIndex]);
        } else {
          console.log(`No se encontró subórden para error, creando nueva:`, error);
          
          // Parsear el detalle del error
          let errorMessage = '';
          const errorDetail = this.parseSimplirouteErrorDetail(error.detail);
          try {
            console.log('Error detail parseado:', errorDetail);
            if (errorDetail && errorDetail.contact_email) {
              errorMessage = `Error de validación: ${errorDetail.contact_email.join(', ')}`;
            } else if (errorDetail && errorDetail.reference) {
              errorMessage = `Error en referencia: ${errorDetail.reference}`;
            } else {
              errorMessage = `Error de procesamiento: ${error.detail}`;
            }
          } catch (e) {
            console.log('Error parseando JSON, usando detalle tal como viene:', error.detail);
            errorMessage = `Error de procesamiento: ${error.detail}`;
          }
          
          // Crear nueva subórden con error
          const newSuborder = {
            suborder: parseInt(errorSoc) || errorSoc,
            lpn: errorLpn,
            last_state_name: 'Digitado', // Estado por defecto
            hasError: true,
            errorType: errorCategory,
            observations: [{
              message: errorMessage,
              timestamp: new Date().toISOString(),
              type: 'error',
              category: errorCategory,
            }]
          };
          
          // Agregar al listado
          this.suborders.push(newSuborder);
          
          console.log('Nueva subórden creada con error:', newSuborder);
        }
      });
      
      console.log('=== processSimplirouteErrors FIN ===');
      console.log('Estado final de subórdenes después de procesar errores:');
      this.suborders.forEach((suborder, index) => {
        console.log(`Subórden ${index}:`, {
          suborder: suborder.suborder,
          lpn: suborder.lpn,
          last_state_name: suborder.last_state_name,
          hasError: suborder.hasError,
          errorType: suborder.errorType,
          observations: suborder.observations
        });
      });
    },
    handleBatchCancelled() {
      // El usuario canceló el proceso
      trackBusinessFlow({
        module: 'planning',
        flow: 'simpliroute_visits',
        action: 'batch_cancelled',
        status: 'cancelled',
        context: {
          history_code: this.historyCode,
        },
      });
    },
    // Método para remover subórdenes procesadas exitosamente
    removeProcessedSuborders(processedSuborders) {
      console.log('=== removeProcessedSuborders INICIO ===');
      console.log('processedSuborders recibidas:', processedSuborders);
      console.log('processedSuborders.length:', processedSuborders ? processedSuborders.length : 0);
      
      // Verificar que this.suborders existe y es un array
      if (!this.suborders || !Array.isArray(this.suborders)) {
        console.error('this.suborders no está definido o no es un array');
        return;
      }
      
      const processedNumbers = processedSuborders.map(s => s.suborder);
      
      console.log('processedNumbers extraídos:', processedNumbers);
      console.log('Subórdenes actuales antes de filtrar:', this.suborders.length);
      console.log('Subórdenes actuales:', this.suborders.map(s => ({ 
        suborder: s.suborder, 
        observations: s.observations,
        hasError: s.hasError,
        last_state_name: s.last_state_name
      })));
      console.log('Subórdenes que deberían removerse:', processedNumbers);
      
      // Filtrar subórdenes del listado principal
      // Remover las procesadas exitosamente (las que están en la lista de procesadas)
      const filteredSuborders = this.suborders.filter(suborder => {
        const shouldRemove = processedNumbers.includes(suborder.suborder);
        console.log(`Subórden ${suborder.suborder}: ${shouldRemove ? 'REMOVER' : 'MANTENER'}`);
        return !shouldRemove; // Si está en la lista de procesadas, removerla
      });
      
      // Usar splice para mutar el array original y que Vue detecte el cambio
      this.suborders.splice(0, this.suborders.length, ...filteredSuborders);
      
      // Forzar actualización de la vista
      this.$forceUpdate();
      
      console.log('Subórdenes después de filtrar:', this.suborders.length);
      console.log('Subórdenes finales:', this.suborders.map(s => ({ 
        suborder: s.suborder, 
        observations: s.observations,
        hasError: s.hasError 
      })));
      
      // Actualizar sectores - remover subórdenes procesadas exitosamente
      this.sectors = this.sectors.map(sector => ({
        ...sector,
        suborders: sector.suborders.filter(suborder => {
          return !processedNumbers.includes(suborder.suborder);
        })
      }));
      
      // Recalcular estadísticas
      this.updateStatistics();
      
      // Verificar paginación después de remover subórdenes
      this.$nextTick(() => {
        if (this.$refs.suborderList && this.$refs.suborderList.verifyPaged) {
          this.$refs.suborderList.verifyPaged();
        }
      });
    },
    // Método para marcar subórdenes con observaciones
    markSubordersWithObservations(data) {
      console.log('=== markSubordersWithObservations INICIO ===');
      console.log('data.filteredSuborders:', data.filteredSuborders);
      console.log('data.filteredSuborders.length:', data.filteredSuborders ? data.filteredSuborders.length : 0);
      
      // Marcar subórdenes filtradas (no enviadas) - solo estas
      if (data.filteredSuborders && data.filteredSuborders.length > 0) {
        console.log('Agregando observaciones a subórdenes filtradas...');
        this.addObservationsToSuborders(data.filteredSuborders, 'No enviada - Filtrada por estado');
      }
      
      console.log('=== markSubordersWithObservations FIN ===');
    },
    // Agregar observaciones a subórdenes
    addObservationsToSuborders(suborders, observation) {
      console.log('=== addObservationsToSuborders INICIO ===');
      console.log('suborders:', suborders);
      console.log('observation:', observation);
      
      suborders.forEach(suborder => {
        // Buscar la subórden en el listado principal
        const index = this.suborders.findIndex(s => s.suborder === suborder.suborder);
        if (index !== -1) {
          // Inicializar observaciones si no existen
          if (!this.suborders[index].observations) {
            this.suborders[index].observations = [];
          }
          
          // Verificar si ya existe esta observación para evitar duplicados
          const existingObservation = this.suborders[index].observations.find(obs => 
            obs.message === observation
          );
          
          if (!existingObservation) {
            this.suborders[index].observations.push({
              message: observation,
              timestamp: new Date().toISOString(),
              type: observation.includes('Error') ? 'error' : 'warning'
            });
          }
          
          // Marcar solo las que realmente tienen errores
          if (observation.includes('Error')) {
            this.suborders[index].hasError = true;
            this.suborders[index].errorType = 'processing';
          } else if (observation.includes('Filtrada')) {
            this.suborders[index].hasError = true;
            this.suborders[index].errorType = 'filtered';
          }
        }
      });
    },
    // Método para actualizar estadísticas después de procesar
    updateStatistics() {
      console.log('updateStatistics llamado');
      console.log('Subórdenes antes de recalcular:', this.suborders.length);
      
      // Recalcular contadores de sectores
      this.sectors = this.sectors.map(sector => {
        const socs = this.suborders.filter(soc => 
          soc.sectors.length > 0 && soc.sectors[0].id === sector.id
        );
        return {
          ...sector,
          suborders: socs.map(s => s.suborder),
          currentVolume: socs.reduce((acum, el) => acum + el.volume, 0),
          currentPrice: socs.reduce((acum, el) => acum + el.price, 0),
          socRedStatus: socs.filter(s => [5, 6].includes(s.last_state)).length,
        };
      });
    },
    getValidation(validation) {
      this.checkedPlanning = validation;
    },
    getExtraDataErrors(data) {
      this.extraDataErrors = data;
    },
    getSuborderErrors(data) {
      this.suborderErrors = data;
    },
    getSectorErrors(data) {
      this.sectorErrors = data;
    },
    getCountSocWithoutSector(count) {
      this.countSocWithoutSector = count;
    },
    applyConfiguration(config) {
      Object.entries(config).forEach(([k, v]) => {
        if (k === 'alg_settings') {
          Object.entries(config.alg_settings).forEach(([k2, v2]) => {
            this.extraData.alg_settings[k2] = v2;
          });
        } else if (k !== 'planBy' && k !== 'sectors') {
          this.extraData[k] = v;
        }
      });
      if (config.sectors.length > 0) {
        this.sectors = config.sectors;
        this.sectors.forEach((s) => {
          // eslint-disable-next-line no-param-reassign
          if (!s.mode) s.mode = 'LOCALIDAD';
        });
        this.countSector = config.sectors.length;
      }
      this.$notify({
        title: 'Configuración aplicada',
        type: 'success',
      });
    },
    filterMe(arr, el, equal) {
      return equal ? arr.filter(l => l === el) : arr.filter(l => l !== el);
    },
  },
  computed: {
    dataToGetTO() {
      return {
        ct: this.extraData.ct,
        date: this.extraData.time_init,
      };
    },
    dataToConfig() {
      return Object.assign({},
        this.extraData,
        {
          sectors: this.sectors.map((s, index) => ({
            id: index + 1,
            mode: s.mode,
            name: s.name,
            pinned: true,
            suborders: [],
            color: s.color,
            region: s.region,
            polygon: s.polygon,
            vehicles: s.vehicles,
            localities: s.localities,
            enterprise: s.enterprise,
            packageTypes: s.packageTypes,
            maximumPrice: s.maximumPrice,
            maximumVolume: s.maximumVolume,
          })),
        });
    },
    dataToMap() {
      // [{"price":20900,"volume":0.000052,"lat":-33.24762389,"lng":-33.24762389,]
      if (!this.suborders || !Array.isArray(this.suborders)) {
        return [];
      }
      return this.sectors.filter(s => s.suborders.length > 0 && s.pinned)
        .map((sector) => {
          const socs = this.suborders
            .filter(soc => soc.sectors && soc.sectors.length > 0 && soc.sectors[0].id === sector.id);
          return { color: sector.color, points: socs.map(s => ({ lat: s.lat, lng: s.lng })) };
        });
    },
    extraDataValid() {
      return this.extraDataErrors.length === 0;
    },
    sectorsToSoc() {
      return this.sectors
        .map(s => ({
          id: s.id,
          name: s.name,
          mode: s.mode,
          color: s.color,
          polygon: s.polygon,
          localities: s.localities,
          packageTypes: s.packageTypes,
        }));
    },
    sectorList() {
      return this.sectors.map((sector) => {
        const socs = this.suborders
          .filter(soc => soc.sectors.length > 0 && soc.sectors[0].id === sector.id);
        const currentVolume = socs.reduce((acum, el) => acum + el.volume, 0);
        const currentPrice = socs.reduce((acum, el) => acum + el.price, 0);
        const suborders = socs.map(s => s.suborder);
        const socRedStatus = socs.filter(s => [5, 6].includes(s.last_state)).length;
        let localities = socs.filter(s => s.locality !== '').map(s => s.locality);
        const topLocalities = [];
        while (localities.length > 0) {
          const count = this.filterMe(localities, localities[0], true).length;
          topLocalities.push([localities[0], count]);
          localities = this.filterMe(localities, localities[0], false);
        }
        topLocalities.sort((a, b) => (a[1] > b[1] ? -1 : 1)).splice(3);
        return Object.assign(sector, {
          suborders, topLocalities, currentVolume, currentPrice, socRedStatus,
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  .el-col { padding-bottom: 35px; }
</style>
